<template>
  <div class="date-range-field-wrapper" :class="{ 'date-field--danger': state === 'danger' }">
    <img :src="iconSrc" alt="calendar" class="date-left-icon" />
    <DatePicker
      v-model="model"
      :range="true"
      :value-type="'format'"
      :format="'YYYY-MM-DD'"
      :editable="false"
      :input-attr="{ placeholder: placeholder }"
      :disabled-date="disabledDate"
      :clearable="false"
      :unlink-panels="true"
      :range-separator="' - '"
    />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'DateRangeField',
  components: { DatePicker },
  props: {
    // Use .sync when consuming:
    // <DateRangeField :start.sync="stay.start_date" :end.sync="stay.end_date" />
    start: { type: String, default: '' },    // 'YYYY-MM-DD'
    end: { type: String, default: '' },      // 'YYYY-MM-DD'
    min: { type: String, default: undefined }, // 'YYYY-MM-DD'
    placeholder: { type: String, default: '' },
    state: { type: String, default: undefined } // e.g. 'danger'
  },
  computed: {
    model: {
      get() {
        const s = this.start || ''
        const e = this.end || ''
        return [s, e]
      },
      set(val) {
        if (Array.isArray(val)) {
          const [s, e] = val
          this.$emit('update:start', s || '')
          this.$emit('update:end', e || '')
        } else {
          // fallback safety
          this.$emit('update:start', '')
          this.$emit('update:end', '')
        }
      }
    },
    iconSrc() {
      return require('../../assets/icons/input/date.png')
    }
  },
  methods: {
    disabledDate(date) {
      // Disable dates before min, if provided
      if (!this.min) return false
      try {
        const d = new Date(date)
        d.setHours(0, 0, 0, 0)
        const min = new Date(this.min + 'T00:00:00')
        min.setHours(0, 0, 0, 0)
        return d < min
      } catch (e) {
        return false
      }
    }
  }
}
</script>

<style scoped>
.date-range-field-wrapper {
  width: 100%;
  position: relative;
}

/* Danger state styling */
.date-field--danger :deep(.mx-input) {
  border-color: #e24c4c !important;
  box-shadow: 0 0 0 1px rgba(226, 76, 76, 0.2) !important;
}

/* Ensure consistent sizing */
:deep(.mx-input) {
  height: 44px;
  font-size: 16px;
  width: 100%;
  /* room for our left icon */
  padding-left: 44px !important;

  /* remove outline/ring */
  outline: none !important;
  box-shadow: none !important;
}
:deep(.mx-input:focus),
:deep(.mx-input:hover),
:deep(.mx-input:focus-within) {
  outline: none !important;
  box-shadow: none !important;
}
/* also ensure wrapper doesn't add ring */
:deep(.mx-datepicker:focus-within) {
  outline: none !important;
  box-shadow: none !important;
}
/* hide default clear icon if any (extra safety) */
:deep(.mx-datepicker .mx-icon-clear) {
  display: none !important;
}
/* hide default calendar icon on the right */
:deep(.mx-datepicker .mx-icon-calendar) {
  display: none !important;
}
/* our left calendar icon */
.date-left-icon {
  position: absolute;
  left: 4px;
  top: 50%;
  transform: translateY(-50%);
  width: 28px;
  height: 28px;
  pointer-events: none;
  opacity: 0.9;
}


</style>
<style>
/* Always hide the 2nd calendar panel in range mode (show a single month) */
.mx-range-wrapper .mx-calendar.mx-calendar-panel-date:nth-child(2) {
  display: none !important;
}

.mx-input-wrapper > input {
  border: none!important;
}
.mx-datepicker {
  width: calc(100% - 40px)!important
}
</style>